import Vue from 'vue';
import Component from 'vue-class-component';
import {DownloadHelper} from '../../../../helpers/download';
import {Watch, Prop} from 'vue-property-decorator';
import {DataManager, Visualisation, Toolbar, Chart, FilterBar, CustomDynamicView} from 'wc-visualisation';
import {Table, Icon, Popover, pivotData, formatDate, FieldType, downloadCsv, arrayToCsv} from 'wc-lib';

require('wc-lib/icons/import-limit.svg');
require('wc-lib/icons/export-limit.svg');
require('wc-lib/icons/flow-left.svg');
require('wc-lib/icons/flow-right.svg');

@Component({
  template: require('./dispatch-overview-interconnector.html'),
  name: 'dispatch-overview-interconnector',
  components: {
    'vis-visualisation': Visualisation,
    'vis-toolbar': Toolbar,
    'wc-icon': Icon,
    'wc-table': Table,
    'vis-chart': Chart,
    'vis-filter-bar': FilterBar,
    'wc-popover': Popover
  }
})
export class NemDispatchOverviewInterconnector extends Vue {
  @Prop()
  interconnector: any;

  @Prop()
  vertical: boolean;

  get isImporting() {
    return this.interconnector.value < 0;
  }

  get isExporting() {
    return this.interconnector.value > 0;
  }

  get highlight() {
    return this.interconnector.value <= this.interconnector.importlimit || this.interconnector.value >= this.interconnector.exportlimit;
  }

  get arc() {
    const percentage = this.percentage;
    if (percentage > 0)
      return this.generateArc(50, 50, 40, 0, 360 * percentage - 1);

    return '';
  }

  get percentage() {
    if (this.isImporting) {
      return  Math.min((Math.abs(this.interconnector.value) / Math.abs(this.interconnector.importlimit)), 1);
    } else if (this.isExporting) {
      return  Math.min((Math.abs(this.interconnector.value) / Math.abs(this.interconnector.exportlimit)), 1);
    }

    return 0;
  }

  polarToCartesian(centerX, centerY, radius, angleInDegrees) {
    const angleInRadians = (angleInDegrees-90) * Math.PI / 180.0;
  
    return {
      x: centerX + (radius * Math.cos(angleInRadians)),
      y: centerY + (radius * Math.sin(angleInRadians))
    };
  }
  
  generateArc(x, y, radius, startAngle, endAngle){
    const start = this.polarToCartesian(x, y, radius, endAngle);
    const end = this.polarToCartesian(x, y, radius, startAngle);
    const largeArcFlag = endAngle - startAngle <= 180 ? "0" : "1";

    return [
        "M", start.x, start.y, 
        "A", radius, radius, 0, largeArcFlag, 0, end.x, end.y
    ].join(" "); 
  }
  
}



// WEBPACK FOOTER //
// src/views/electricity/nem/dispatch-overview/dispatch-overview-interconnector.ts